<template>
  <div>
    <modal-wrapper>
      <modal-container
        v-if="showQrCodeScan"
        class="sharing-modal"
        :show-close="true"
        @close="showConfirmModal=true"
      >
        <div class="register-page__modal-img-wrap">
          <template v-if="qrCodeData.type === 'link'">
            <a v-if="qrCodeData.img" :href="qrCodeData.dynamic_deeplink" target="_blank">
              <img
                :src="'data:image/png;base64,' + qrCodeData.img"
                class="register-page__modal-img"
                width="220"
                height="220"
              />
            </a>
            <img
              v-else
              class="diya-waiting__loader m-0"
              width="130"
              height="130"
              src="@/assets/img/loader.svg"
            />
          </template>
          <template v-else>
            <img
              v-if="qrCodeData.img"
              :src="'data:image/png;base64,' + qrCodeData.img"
              class="register-page__modal-img"
              width="220"
              height="220"
            />
            <img
              v-else
              class="diya-waiting__loader m-0"
              width="130"
              height="130"
              src="@/assets/img/loader.svg"
            />
          </template>

        </div>
        <template v-if="qrCodeData.type === 'link'">
          <div class="register-page__modal-sub-text text-left">
            {{ $t('qr-code.scan-qr-mobile-subtext1') }}
          </div>
          <div class="register-page__modal-sub-text text-left">
            {{ isDocSign ? $t('qr-code.scan-qr-mobile-diia-sign-subtext2') : $t('qr-code.scan-qr-mobile-subtext2') }}
          </div>
        </template>
        <template v-else>
          <div class="register-page__modal-text text-left">
            {{ $t('qr-code.scan-qr') }}
          </div>
          <div class="register-page__modal-sub-text text-left">
            {{ isDocSign ? $t('qr-code.scan-qr-diia-subtext') :$t('qr-code.scan-qr-subtext') }}
          </div>
        </template>

        <div class="register-page__modal-buttons vertical">
          <div v-if="showUpdateQrLink" class="error">
            <template v-if="qrCodeData.type === 'link'">
              {{ $t('qr-code.scan-qr-mobile-error') }}
            </template>
            <template v-else>
              {{ $t('qr-code.scan-qr-error') }}
            </template>
          </div>
          <pc-button variant="dark" :disabled="!(!qrCodeData.type || !secondsLeftToActivate)" @click="getStatus()">
            <template v-if="secondsLeftToActivate">
              {{ $t('qr-code.scan-qr-block-text', {sec: secondsFormat}) }}
            </template>

            <template v-else>
              {{ $t('qr-code.proceed') }}
            </template>
          </pc-button>
          <div
            v-if="showUpdateQrLink"
            class="back-link"
            @click="updateQrCode"
          >
            {{ $t('qr-code.update-qr') }}
          </div>
        </div>
      </modal-container>

      <modal-container
        v-if="showPending"
        class="diya-waiting sharing-modal"
        :show-close="false"
      >
        <div class="diya-waiting__title">
          {{ $t('qr-code.waiting') }}
        </div>
        <div class="diya-waiting__img-wrap">
          <img
            class="diya-waiting__loader"
            width="110"
            height="110"
            src="@/assets/img/loader.svg"
          />
        </div>
        <br />
        <div>{{ $t('qr-code.contacts') }}</div>
        <icu-contacts view-type="horizontal" :show-phone="false" email-to="support" />

      </modal-container>

      <modal-container
        v-if="showResult"
        :show-close="res.showCloseButton"
        class="sharing-modal"
        @close="closeHandler"
      >
        <div class="sharing-modal__img-wrap">
          <img
            v-if="result === 'waiting'"
            class="diya-waiting__loader"
            width="110"
            height="110"
            src="@/assets/img/loader.svg"
          />
          <img
            v-else
            :src="img"
            class="register-page__modal-img"
            width="200"
            height="160"
          />
        </div>
        <div
          class="main-text"
          :style="{'text-align': res.mainTextAlign || 'left'}"
          v-html="$t(res.mainText)"
        />

        <div v-if="res.subText" class="sub-text">
          {{ $t(res.subText) }}
        </div>
        <br v-else />

        <div class="register-page__modal-buttons vertical">
          <pc-button variant="dark" :disabled="!!secondsLeftToActivate" @click="callAction(res.button1.action)">
            <template v-if="secondsLeftToActivate">
              {{ $t('qr-code.scan-qr-block-text', {sec: secondsFormat}) }}
            </template>

            <template v-else>
              {{ $t(res.button1.text) }}
            </template>
          </pc-button>
          <div v-if="managerModalError && result === 'notUniqueData'" class="register-page-match__error">
            {{ $t(managerModalError) }}
          </div>

          <pc-button v-if="res.button2" variant="void" @click="callAction(res.button2.action)">
            {{ $t(res.button2.text) }}
          </pc-button>
          <div
            v-if="res.showBackToSiteButton"
            class="back-link"
            @click="returnToSite"
          >
            {{ $t('qr-code.back-to-site') }}
          </div>
          <br v-else />
        </div>
        <div v-if="res.showContacts" class="contacts">
          <icu-contacts email-to="support"></icu-contacts>
        </div>

      </modal-container>


    </modal-wrapper>
    <modal-wrapper v-if="showConfirmModal">
      <modal-container
        :show-close="false"
        class="confirm-modal"
      >
        <div class="logout-modal__header">
          <img
            src="@/assets/img/logo.svg"
            class="register-page__modal-logo"
            width="100"
            height="40"
            alt="ICU"
          />
        </div>
        <h2 class="h1">
          {{ isDocSign? $t('qr-code.cancel-diia-sign-request') :$t('qr-code.cancel-registration-request') }}
        </h2>
        <div class="register-page__modal-buttons">
          <pc-button variant="dark" @click="showConfirmModal=false">
            {{ isDocSign ? $t('qr-code.continue-diia-sign') : $t('qr-code.continue-registration') }}
          </pc-button>

          <pc-button v-if="isDocSign" variant="void" @click="returnToSign">
            {{ $t('qr-code.cancel-diia-sign') }}
          </pc-button>
          <pc-button v-else variant="void" @click="returnToSite">
            {{ $t('qr-code.cancel-diia-sign') }}
          </pc-button>
        </div>
      </modal-container>
    </modal-wrapper>
    <common-modal
      v-if="isManagerModalDisplayed"
      :heading="$t('duplicate-check.manager-has-been-notified')"
      :img-src="require('@/assets/img/components/modals/phone.png')"
      @close="$router.push({name: 'login'})"
    />
  </div>

</template>

<script>
import ModalWrapper from '@/components/modals/ModalWrapper'
import ModalContainer from '@/components/modals/ModalContainer'
import PcButton from '@/components/common/PcButton.vue'
import IcuContacts from '@/components/common/IcuContacts'
import {api} from '@/api/api'
import CommonModal from '@/components/modals/CommonModal'

export default {
  name: 'DiyaQrCode',
  components: {
    CommonModal,
    IcuContacts,
    PcButton,
    ModalContainer,
    ModalWrapper
  },
  disabledButtonSeconds: 10,
  counter: null,
  diyaPopupResults: {
    processing: {
      img: 'warning',
      mainText: 'qr-code.qr-proceed-to-finish',
      mainTextAlign: 'center',
      button1: {
        text: 'qr-code.proceed',
        action: 'getStatus'
      },
      showBackToSiteButton: false,
      showContacts: false,
      showCloseButton: true
    },
    notUsed: {
      img: 'warning',
      mainText: 'qr-code.qr-expired',
      mainTextAlign: 'center',
      button1: {
        text: 'qr-code.try-again',
        action: 'showQrScan'
      },
      showBackToSiteButton: false,
      showContacts: false,
      showCloseButton: true
    },
    refuse: {
      img: 'warning',
      mainText: 'qr-code.qr-error',
      mainTextAlign: 'center',
      button1: {
        text: 'qr-code.try-again',
        action: 'showQrScan'
      },
      showBackToSiteButton: false,
      showContacts: false,
      showCloseButton: true
    },
    waiting: {
      img: 'loader',
      mainText: 'qr-code.account-opening-process',
      button1: {
        text: 'qr-code.back-to-site',
        action: 'returnToSite'
      },
      showBackToSiteButton: false,
      showContacts: true
    },
    success: {
      img: 'success',
      mainText: 'qr-code.process-success',
      subText: '',
      button1: {
        text: 'qr-code.go-to-cabinet',
        action: 'goToTradeCabinet'
      },
      showBackToSiteButton: false,
      showContacts: true
    },
    doc_sign_success: {
      img: 'success',
      mainText: 'qr-code.scan-qr-doc-sign-success',
      subText: '',
      button1: {
        text: 'qr-code.scan-qr-doc-sign-success-to-cabinet',
        action: 'goToCabinet'
      },
      showBackToSiteButton: false,
      showContacts: true
    },

    error:{
      img: 'invalid',
      mainText: 'qr-code.error-text',
      subText: 'qr-code.error-hint',
      button1: {
        text: 'qr-code.try-diya',
        action: ''
      },
      button2: {
        text: 'qr-code.register-bank-id',
        action: ''
      },
      showBackToSiteButton: true,
      showContacts: false
    },
    noFullData: {
      img: 'invalid',
      mainText: 'qr-code.no-full-data-text',
      subText: 'qr-code.no-full-data-hint',
      button1: {
        text: 'qr-code.try-diya',
        action: 'updateQrCode'
      },
      button2: {
        text: 'qr-code.register-bank-id',
        action: ''
      },
      showBackToSiteButton: true,
      showContacts: false
    },
    notUniqueData: {
      img: 'warning',
      mainText: 'qr-code.not-unique-data',
      button1: {
        text: 'qr-code.call-manager',
        action: 'contactManager'
      },
      showBackToSiteButton: false,
      showContacts: true
    }
  },
  data() {
    return {
      isDocSign: false,
      result: '',
      email: '',
      phone:'',
      showQrCodeScan: false,
      showUpdateQrLink: false,
      showPending: false,
      showResult: false,
      showConfirmModal: false,
      isManagerModalDisplayed: false,
      secondsLeftToActivate: 0,
      managerModalError: '',
      delay: 0,
      qrCodeData: {
      }
    }
  },
  computed: {
    res() {
      return this.$options.diyaPopupResults[this.result]
    },
    img() {
      return this.getImgUrl(this.res.img + '.svg')
    },
    secondsFormat() {
      const str = this.secondsLeftToActivate.toString()
      return this.secondsLeftToActivate > 9 ? str : '0'+ str
    }
  },

  async mounted() {
    this.isDocSign = this.$route.name === 'diya-qr-code-sign'
    try {
      const {data} = await api.profile.settings()
      this.delay = data.DELAY_BEFORE_SHARING_REDIRECT
    } catch (err){
      console.log(err)
    }


    if(!this.isDocSign){
      this.phone = this.$route.params.phone
      this.email = this.$route.params.email
    }

    if (this.$route.params.skipCheck){
        await this.updateQrCode()
        this.showQrCodeScan = true

    } else {

      if (this.$route.query.state) {
        this.result = this.$route.query.state
        this.showResult = true

      } else {
        this.getStatus()
      }
    }
  },

  methods: {
    closeHandler() {

      if(this.isDocSign && this.result === 'doc_sign_success'){
        this.goToTradeCabinet()
      } else {
        this.showConfirmModal=true
      }
    },
    getStatus() {
      if(this.isDocSign) {
        this.getDiyaSignStatus()
      } else {
        this.getDiyaStatus()
      }
    },
    async returnToSign () {
      await this.$router.push({name: 'document-sign'})
    },
    async getQrCode(update = false){
      let method = null
      if(this.isDocSign){
        method = update ? 'updateSignDocQrCode': 'getSignDocQrCode'
      }else {
        method = update ? 'updateQrCode' : 'getQrCode'
      }
      this.qrCodeData = {}
      this.sharingStatus = ''
      try {

        const {data} = await api.profile.resident[method].get()
        this.qrCodeData = data
        if(update){
          this.showUpdateQrLink = false
          this.startCountdown()

        }
      }catch(err){
        console.log(err)
      }
    },

    updateQrCode() {
      this.getQrCode(true)
    },

    async getDiyaStatus(showPending = true, handleResults = true) {
      this.showResult = false
      this.showQrCodeScan = false
      this.showPending = showPending
      try {
        const {data} = await api.profile.resident.sharingResult()
        this.email = data.email
        this.phone = data.phone
        if( handleResults) {
          if (data.doubles?.profile_status) {
            this.showResult = true
            this.showPending = false
            this.showQrCodeScan = false
            switch (data.doubles.profile_status) {
              case 'LAUNCHING':
                this.result = 'waiting'
                break
              case  'EXISTING':
                this.result = 'success'
                break
              case 'NOLOGIN': {
                this.result = 'notUniqueData'
                break
              }
            }
            return
          }
          if (!data.success) {
            this.handleResult(data.status)
          } else {
            if (!data.profile_status) {
              this.$router.push({
                name: 'register',
                query: {
                  phone: data.phone,
                  email: data.email,
                  is_resident: true,
                  interface_language: this.$i18n.locale,
                  register_datasource: 'SHARING',
                  set_password: true
                }
              })
            }
          }
        }
      }catch(err) {
        if(err.response?.status === 404) {
          await this.$router.push({name:'register'})
        }
        console.log(err)
      }
      this.showPending = false
    },

    async getDiyaSignStatus(showPending = true, handleResults = true) {
      this.showResult = false
      this.showQrCodeScan = false
      this.showPending = showPending
      try {
        const {data} = await api.profile.resident.checkDiiaSignDocResult.get()
        if( handleResults) {

          if (!data.success) {
            await this.handleResult(data.status)
          } else {
            this.result= 'doc_sign_success'
            this.showResult = true
          }
        }
      }catch(err) {
        if(err.response?.status === 404) {
          await this.$router.push({name:'document-sign'})
        }
        this.$toast.error(this.$t('notifications.something-went-wrong'))
        console.log(err)
        await this.updateQrCode()
        this.showQrCodeScan = true
      }
      this.showPending = false
    },

    async handleResult(status) {
        switch (status) {
          case 'initialized':
            if(!Object.keys(this.qrCodeData).length) {
              await this.getQrCode()
              this.showUpdateQrLink = false
            } else {
              this.showUpdateQrLink = true
            }
            this.startCountdown()
            this.showQrCodeScan = true
            break

          case 'refuse':
            this.showQrCodeScan = false
            this.result= 'refuse'
            this.showUpdateQrLink = false
            this.showResult = true
            break

          case 'notUsed':
            this.showQrCodeScan = false
            this.result= 'notUsed'
            this.showResult = true
            break

          case 'processing':
            this.startCountdown()
            this.showQrCodeScan = false
            this.result= 'processing'
            this.showResult = true
            break
        }
    },

    startCountdown() {
      this.secondsLeftToActivate = this.$options. disabledButtonSeconds
      clearInterval(this.$options.counter)
      this.$options.counter = setInterval(() => {
        this.secondsLeftToActivate --
        if(this.secondsLeftToActivate <= 0) {
          clearInterval(this.$options.counter)
        }
      },1000)
    },

    callAction(funcName) {
      this[funcName]()
    },

    getImgUrl(pic) {
      return require('@/assets/img/'+pic)
    },

    returnToSite() {
      window.location = process.env.VUE_APP_LANDING_REDIRECT_URL
    },

    showQrScan() {
      this.updateQrCode()
      this.showQrCodeScan = true
      this.startCountdown()
      this.showResult = false
    },

    async contactManager() {
      try {
        await api.auth.mailManager({
          email: this.email,
          phone: this.phone
        })

        this.managerModalError = ''
        this.isManagerModalDisplayed = true
      } catch (e) {
        if (e.response.status === 429) {
          this.managerModalError = 'register.already-requested'
        } else {
          this.$toast.error('Щось пішло не так')
        }
      }
    },

    goToTradeCabinet() {
      window.location = 'https://trade.online.icu/login'
    },
    async goToCabinet() {
      await this.$router.push({name:'profile'})
    },

  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/theme.scss";
@import "~@/assets/scss/views/register-common.scss";
.diya-waiting {
  text-align: center;

  &__title {
    font-weight: 600;
    font-size: 20px;
    padding-top: 60px;
  }

  &__img-wrap {
    min-height: 340px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__loader {
    animation: spin 2s linear infinite;
    transform-origin: 53% 50%;
    margin: 70px auto 50px;
    &.m-0 {
      margin: 45px 0;
    }
  }
}

.main-text {
  font-weight: 600;
  font-size: 20px;
}

.sub-text {
  padding-top: 20px;
}

.back-link {
  display: flex;
  justify-content: center;
  text-decoration: underline;
  cursor: pointer;
  margin: 15px 0 5px;
  font-weight: 700;
  color: $active-green ;
}

.contacts {
  display: flex;
  margin-top: 20px;
  justify-content: center;
}

.error {
  color: #F87756;
  font-size: 12px;
  font-weight: 400;
}
.sharing-modal {
  min-height: 600px;
  display: flex;
  flex-direction: column;
  &__img-wrap {
    flex-grow: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 250px;
  }
}
h2 {
  text-transform: uppercase;
  text-align: center;
  font-size: 22px;
}

.confirm-btn {
  padding-top: 10px;
  padding-bottom: 10px;
}
.register-page__modal-buttons {
  justify-content: space-around;
}

@media (max-width: 500px){
  .sharing-modal {
    padding-top: 30px;
  }
  .confirm-modal{
    padding-top: 30px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}


@keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
    transform:rotate(360deg);
  }
}
</style>
